import { h } from '../lib/dom.js';
import { getState } from '../store.js';
import { iconMarkup } from '../icons/index.js';
import { cancelConfirmReveal, setConfirmRevealCode, submitConfirmReveal, confirmRevealWithWebauthn } from '../actions.js';
import { t } from '../i18n/index.js';

// feature-harden.md 6.3: this modal now gates recipient add/edit/delete
// too (confirmRevealPurpose), not just a key reveal — copy/button label
// switch per purpose so "Reveal" doesn't show while saving a recipient.
const COPY_BY_PURPOSE = {
  revealKey: { title: 'title', help: 'help', confirm: 'reveal' },
  saveRecipient: { title: 'titleSaveRecipient', help: 'helpSaveRecipient', confirm: 'confirmSaveRecipient' },
  deleteRecipient: { title: 'titleDeleteRecipient', help: 'helpDeleteRecipient', confirm: 'confirmDeleteRecipient' },
  // feature-harden.md 6.6: re-auth to override a per-account send limit.
  moveLimitOverride: { title: 'titleMoveLimitOverride', help: 'helpMoveLimitOverride', confirm: 'confirmMoveLimitOverride' },
  // CCSS-KU (AUDIT.md F3): re-auth to override the new-recipient cooldown
  // or first-payment echo-test limit.
  newRecipientOverride: { title: 'titleNewRecipientOverride', help: 'helpNewRecipientOverride', confirm: 'confirmNewRecipientOverride' }
};

export function renderConfirmRevealModal() {
  const s = getState();
  if (!s.showConfirmReveal) return null;
  const profile = s.profiles.find((p) => p.id === s.activeProfileId) || s.profiles[0];
  const canWebauthn = s.webauthnAvailable && profile && profile.vault && profile.vault.webauthn;
  const copy = COPY_BY_PURPOSE[s.confirmRevealPurpose] || COPY_BY_PURPOSE.revealKey;

  const input = h('input', {
    class: 'code-input',
    value: s.confirmRevealCode,
    placeholder: t('landing.passcodePlaceholder'),
    maxlength: '6',
    inputmode: 'numeric',
    oninput: (e) => setConfirmRevealCode(e.target.value)
  });
  input.addEventListener('keydown', (e) => { if (e.key === 'Enter') submitConfirmReveal(); });

  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, t('modals.confirmReveal.' + copy.title)),
      h('div', { class: 'text-muted modal-help' }, t('modals.confirmReveal.' + copy.help)),
      canWebauthn ? h('button', {
        class: 'btn btn-secondary btn-sm full-width', onclick: confirmRevealWithWebauthn
      }, [h('span', { html: iconMarkup('scanFace', { size: 14 }) }), ' ' + t('modals.confirmReveal.useBiometrics')]) : null,
      input,
      h('div', { class: 'field-error' }, s.confirmRevealError || ''),
      h('div', { class: 'btn-row' }, [
        h('button', { class: 'btn btn-secondary', onclick: cancelConfirmReveal }, t('common.cancel')),
        h('button', { class: 'btn btn-primary', onclick: submitConfirmReveal }, t('modals.confirmReveal.' + copy.confirm))
      ])
    ])
  ]);
}
